import { VerificationConfig } from '@global/types/form';
import { createContext, Dispatch, MutableRefObject, RefObject, SetStateAction } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Verification from '.';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FileUploadState } from '@components/ui/file-tile/states';
import { TxnState } from '@global/constants/verification';
import { HandleChangeArgs } from './types';

type Setter<T> = Dispatch<SetStateAction<T>>;

export interface VerificationContextType {
  states: {
    step: number,
    setStep: Dispatch<SetStateAction<number>>,
    fields: {
      [key: string]: any
    }[],
    setFields: Dispatch<
      SetStateAction<
        {
          [key: string]: any
        }[]
      >
    >,
    multiDocs: {
      profileData: { level: string },
      state: TxnState,
      subType: string,
      marksheet?: { label?: string, url?: string, file?: File } | null,
      request: any,
      responseList: unknown[]
    }[],
    setMultiDocs: React.Dispatch<VerificationContextType['states']['multiDocs']>,
    errors: {
      [key: string]: any
    }[],
    setErrors: Dispatch<
      SetStateAction<
        {
          [key: string]: any
        }[]
      >
    >,
    isLoading: Record<string, boolean>,
    setIsLoading: Dispatch<SetStateAction<Record<string, boolean>>>,
    openCamera: boolean,
    setOpenCamera: Dispatch<SetStateAction<boolean>>,
    consentGiven: boolean,
    setConsentGiven: Dispatch<SetStateAction<boolean>>,
    otpTimeoutSeconds: number,
    setOtpTimeoutSeconds: Dispatch<SetStateAction<number>>,
    showMultiDocTiles: boolean,
    formResponses: any[],
    showSavedReqData: boolean,
    setShowSavedReqData: Dispatch<SetStateAction<boolean>>,
    captchaInfo: {
      [key: string]: any
    },
    subType: string,
    setSubType: React.Dispatch<React.SetStateAction<string>>,
    verificationTxnData: { [key: string]: any }[],
    setVerificationTxnData: React.Dispatch<React.SetStateAction<{ [key: string]: any }[]>>,
    showModal: { [key: string]: any },
    setShowModal: Setter<VerificationContextType['states']['showModal']>,
    isCaptchaNeeded: boolean,
    isCaptchaLoading: boolean,
    globalFileUploadState: FileUploadState,
    setGlobalFileUploadState: React.Dispatch<React.SetStateAction<FileUploadState>>,
    fileUploadModal: boolean,
    setFileUploadModal: React.Dispatch<React.SetStateAction<boolean>>,
    showAuthOptions: any[],
    setShowAuthOptions: React.Dispatch<React.SetStateAction<any[]>>,
    selectedAuthOption: any,
    setSelectedAuthOption: React.Dispatch<React.SetStateAction<any>>
  };
  handlers: {
    handleGoBack: () => void,
    handleChange: (args: HandleChangeArgs) => void,
    handleSubmit: () => void,
    handleAddDegree: (data?: { [key: string]: any }) => void,
    handleEnterKeyPress: (e: any, type: any) => void,
    handleApiCall: (
      updatedFields: any,
      incrementStep?: boolean | undefined,
      flowStep?: number | undefined,
      loadingKey?: string | undefined
    ) => Promise<void>,
    handleFetchCaptcha: () => Promise<void>,
    handlePrefillData: VoidFunction,
    submitMultiDocList: (
      mixpanelKey: 'submit' | 'edit',
      tempFields: any,
      flowStep: number
    ) => Promise<void>,
    handleMarkAsSkip: () => Promise<void>
  };
  misc: {
    verification: any,
    timerRef: MutableRefObject<null>,
    configData: VerificationConfig,
    scrollableRef: RefObject<HTMLDivElement>,
    isProfileVerification: boolean,
    profileState: TxnState | '',
    txnState: TxnState | '',
    mixpanelVerificationData: any
  };
}

/**
 * @see {@link Verification} for the Provider (of this context)
 * @see {@link useVerification} for the states and the function definitions
 */
const VerificationContext = createContext<VerificationContextType | null>(null);

export default VerificationContext;
